module.exports = __webpack_public_path__ + "static/media/apartment9.47940441.jpg";